import { useMemo, useState } from "react"
import type { LineManagerAssignment } from "../AssignLineManagerDeputy/AssignLineManagerDeputy.static"

export const useRemoveLineManagerAssignments = (assignments: readonly LineManagerAssignment[]) => {
  const [removalTicketUrl, setRemovalTicketUrl] = useState("")
  const [searchTerm, setSearchTerm] = useState("")
  const [selectedAssignmentId, setSelectedAssignmentId] = useState<string | undefined>(undefined)

  // TODO: wire backend active-assignment search rather than filtering only the local session list.
  const filteredAssignments = useMemo(() => {
    const normalizedSearchTerm = searchTerm.trim().toLowerCase()

    if (!normalizedSearchTerm) return assignments

    return assignments.filter(({ currentLineManager, temporaryDeputy }) =>
      [currentLineManager, temporaryDeputy].some(value => value.toLowerCase().includes(normalizedSearchTerm)),
    )
  }, [assignments, searchTerm])

  const selectedAssignment = assignments.find(({ id }) => id === selectedAssignmentId)
  const openRemovalDialog = (id: string) => setSelectedAssignmentId(id)
  const closeRemovalDialog = () => {
    setRemovalTicketUrl("")
    setSelectedAssignmentId(undefined)
  }

  return {
    closeRemovalDialog,
    filteredAssignments,
    openRemovalDialog,
    removalTicketUrl,
    selectedAssignment,
    setRemovalTicketUrl,
    setSearchTerm,
    searchTerm,
  }
}
